/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface MedicareCardReaderOutput {
  /** Whether the image is an Original Medicare (red, white and blue) card. */
  is_medicare_card?: boolean;
  first_name?: string | null;
  last_name?: string | null;
  medicare_beneficiary_id?: string | null;
}
